import { Injectable } from '@angular/core';
import { Config } from './config/config'
import { HttpClient } from '@angular/common/http'
import { StorageService } from './config/storage.service'

@Injectable({
  providedIn: 'root'
})
export class ItemMilestoneService extends Config{

  constructor(
      private http:HttpClient,
      private storage:StorageService,
  ) { 
     super()
  }

  generateNotif($milestone_id){
    let url = 'generate_milestone_notif?milestone_id=' + $milestone_id 
    return this.http.get(this.BASE_URL_API + url,this.storage.getHeaders())
  }


  getMilestones(maxItemsPerPage = 10, page=1){
    let url = 'get_item_milestones?page=' + page + '&maxItemsPerPage=' + maxItemsPerPage
    return this.http.get(this.BASE_URL_API + url,this.storage.getHeaders())
  }

  saveMilestones(item:any){
    let url = 'save_item_milestones'
    return this.http.post(this.BASE_URL_API + url,item,this.storage.getHeaders())
  }

  getMilestoneItems(){
    let url = 'get_milestone_items'
    return this.http.get(this.BASE_URL_API + url,this.storage.getHeaders())
  }


}
